import React, { createContext, useEffect, useState } from 'react';

export const LangContext = createContext();

export const LangProvider = ({ children }) => {  
  const [selectLanguage, setSelectLanguage] = useState('ENGLISH');  

  useEffect(() => {
    console.log(navigator.language);
    switch(navigator.language)
    {
      case 'ko-KR':
        setSelectLanguage('한국어');
        break;
      default:
        setSelectLanguage('ENGLISH');
        break;
    }
  },[])

  return (
    <LangContext.Provider value={{ selectLanguage, setSelectLanguage }}>
      {selectLanguage && children}
    </LangContext.Provider>
  );
};
